/**
 * Application form modal on the single konsultuppdrag template.
 *
 * A native <dialog> hosts the Gravity Forms "Ansökan" form, so focus trap
 * and Esc-to-close come for free. Clicking the backdrop closes the modal;
 * clicks inside the card don't bubble to the dialog element itself since the
 * inner wrapper covers the whole content box.
 */
export function initApplyModal() {
    const modal = document.querySelector('[data-apply-modal]');
    if (!modal) return;

    document.querySelectorAll('[data-apply-modal-open]').forEach((button) => {
        button.addEventListener('click', () => {
            modal.showModal();
            // Gravity Forms defers its initialization (conditional logic,
            // un-hiding the form) while the form sits in a hidden container,
            // and its MutationObserver only watches style/class attributes —
            // the dialog's `open` attribute doesn't wake it. This class
            // toggle does.
            modal.classList.add('is-open');
        });
    });

    modal.querySelectorAll('[data-apply-modal-close]').forEach((button) => {
        button.addEventListener('click', () => modal.close());
    });

    modal.addEventListener('close', () => modal.classList.remove('is-open'));

    modal.addEventListener('click', (event) => {
        if (event.target === modal) modal.close();
    });
}
